import React, { useCallback, useEffect, useState } from 'react'
import { PreLoader } from '../components/PreLoader/PreLoader';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import CommonService from '../services/common.service';
export const AppContext = React.createContext({

})
export const AppProvider = ({ children }) => {
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [isShowSideBar, setIsShowSideBar] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [authenticated, setAuthenticated] = useState(null);
    const [config, setConfig] = useState(null);
    const [paymentGateways, setPaymentGateways] = useState({})
    const [countries, setCountries] = useState([]);
    const [defaultCountry, setDefaultCountry] = useState(null);
    const [defaultMsisdnCountry, setDefaultMsisdnCountry] = useState(null);
    const displayToast = (message, type = 'success') => {
        if(type === 'error'){
            toast.error(message, {
                position: "top-center",
                theme: "dark",
                autoClose: 10000,
            });
        }else if(type === 'warning'){
            toast.warning(message, {
                position: "top-center",
                theme: "dark",
                autoClose: 10000,
            });
            return;
        }else{
            toast.success(message, {
                position: "top-center",
                theme: "dark",
                autoClose: 10000,
            });
        }
        
    }
    const exceptionHandler = (error, actions = null) => {
        if(actions)
            actions.setSubmitting(false);
        let hasError = false;
        if(actions && error.response && error.response.data && error.response.data.hasOwnProperty('errors')){
            Object.keys(error.response.data.errors).map(async (key) => {
                actions.setFieldError(key, t(error.response.data.errors[key][0]))
                hasError = true;
            })
            
        }
        if(!hasError){
            if(error.response && error.response.data && error.response.data.hasOwnProperty('error')){
                displayToast(t(error.response.data.error), 'error');
                hasError = true;
            }
        }
        
        if(!hasError){
            displayToast(t("An error occurred while processing your request."), 'error');
        }
    }
    const detectMedia = useCallback(async () => {
        const mediaQuery = window.matchMedia("(max-width: 768px)");
        setIsMobile(mediaQuery.matches);
        const handler = (e) => {
            setIsMobile(e.matches);
        }
        mediaQuery.addEventListener("change", handler);
        return () => {
            mediaQuery.removeEventListener("change", handler);
        }
        
    }, []);
    const handleLoadCountries = useCallback(async () => {
        const data = await CommonService.countries();
        const items = [];
        data.map(async (country) => {
            items.push({ id: country.id, flag: country.flag, label: country.flag + " " + (country.name), value: country.iso2, code: country.dial_code });
            if(country.is_default){
                setDefaultCountry({ id: country.id, flag: country.flag, name: country.name, label: country.flag + " " + (country.name), value: country.iso2, code: country.dial_code })
                setDefaultMsisdnCountry({ id: country.id, flag: country.flag, name: country.name, label: country.flag + " " + (country.name), value: country.iso2, code: country.dial_code })
            }
        });
        setCountries(items)
    }, [])
    const handleLoadConfigs = useCallback(async () => {
        const data = await CommonService.config();
        setPaymentGateways(data?.PAYMENT_GATEWAYS?.config_value);
        setConfig(data)
    }, [])
    
    useEffect(() => {
        detectMedia()
    }, [detectMedia]);

    useEffect(() => {
        handleLoadConfigs();
        handleLoadCountries();
        setIsLoading(false);
    }, [handleLoadConfigs, handleLoadCountries])
    
    useEffect(() => {
        setIsShowSideBar(!isMobile); 
    }, [isMobile])
    return (
      <AppContext.Provider value={{
            user: authenticated,
            isShowSideBar,
            isMobile,
            config,
            paymentGateways,
            countries,
            defaultCountry,
            defaultMsisdnCountry,
            toggleSidebar : () => {
                setIsShowSideBar(!isShowSideBar)
            },
            setIsShowSideBar,
            authenticate: setAuthenticated,
            displayToast,
            exceptionHandler
        }}>
            <PreLoader show={isLoading} />
            {!isLoading && children}
      </AppContext.Provider>
    );
  };